module.exports = __webpack_public_path__ + "static/media/SignupPage.1cecad52.jpeg";